import { useEffect, useState } from "react";

export const useMinimumDisplayTime = (isActive: boolean, minimumDisplayMilliseconds: number) => {
    const [isDisplayed, setIsDisplayed] = useState(true);

    useEffect(() => {
        if (isActive) {
            setIsDisplayed(true);
            return;
        }

        const timerId = setTimeout(() => {
            setIsDisplayed(false);
        }, minimumDisplayMilliseconds);

        return () => {
            clearTimeout(timerId);
        };
    }, [minimumDisplayMilliseconds, isActive]);

    return isDisplayed;
};
